import React from 'react';
import { motion } from 'framer-motion';
import { NeuralNetwork } from './NeuralNetwork';
interface FeatureCardProps {
  title: string;
  description: string;
  index: number;
}
function FeatureCard({
  title,
  description,
  index
}: FeatureCardProps) {
  return <motion.div className="glass rounded-lg p-5 md:p-6 border-l-2 border-l-ultra-gold/50" initial={{
    opacity: 0,
    x: 60
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    delay: 0.2 + index * 0.15,
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-17">
      <h3 className="font-heading text-base md:text-lg text-ultra-gold-light mb-2" data-id="element-18">
        {title}
      </h3>
      <p className="font-body text-sm md:text-base text-white/70 leading-relaxed" data-id="element-19">
        {description}
      </p>
    </motion.div>;
}
export function EdgeSection() {
  return <section className="relative min-h-screen w-full flex items-center" data-id="element-20">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 60% 50% at 30% 50%, rgba(139,92,246,0.06) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-21" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 py-20" data-id="element-22">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-23">
          {/* Left: Neural Network */}
          <motion.div className="aspect-square max-w-[500px] mx-auto w-full" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} data-id="element-24">
            <NeuralNetwork data-id="element-25" />
          </motion.div>

          {/* Right: Features */}
          <div data-id="element-26">
            <motion.p className="font-heading text-xs md:text-sm uppercase tracking-[0.3em] text-ultra-gold mb-10" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.5
          }} transition={{
            duration: 0.6
          }} data-id="element-27">
              The Edge
            </motion.p>

            <div className="space-y-4 md:space-y-5" data-id="element-28">
              <FeatureCard title="Predictive Behavioral Mapping" description="Anticipate player actions 47 steps ahead using deep temporal modeling" index={0} data-id="element-29" />
              <FeatureCard title="Hyper-Personalized Game Curation" description="Every player sees a casino floor designed uniquely for them" index={1} data-id="element-30" />
              <FeatureCard title="Intelligent Bonus Calibration" description="Dynamic incentives that maximize lifetime value, not just conversion" index={2} data-id="element-31" />
              <FeatureCard title="Sentiment-Driven Engagement" description="Real-time emotional intelligence adjusts the experience mid-session" index={3} data-id="element-32" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}